var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    colors = _ref.colors,
    typography = _ref.typography,
    spacing = _ref.spacing;
  return {
    borderColor: colors.contrasts.white1010,
    bottomBorderColor: colors.contrasts.grey1214,
    bottomBorderWidth: borders.widthSmall,
    darkTextColor: colors.contrasts.grey125125,
    hoverBorderColor: colors.contrasts.blue4570,
    hoverBorderWidth: borders.widthLarge,
    infoHeaderColor: colors.contrasts.grey4570,
    infoHeaderFontSize: typography.fontSizeXSmall,
    itemBodyFontSize: typography.fontSizeSmall,
    itemBodyMarginTop: spacing.xxSmall,
    mainTextPaddingTop: spacing.xSmall,
    numberFontSize: typography.fontSizeMedium,
    numberFontWeight: typography.fontWeightBold,
    sidebarClosedMargin: '-' + spacing.xSmall,
    sidebarClosedPadding: spacing.small,
    sidebarIsOpenMainTextFontSize: typography.fontSizeXSmall,
    sidebarIsOpenPadding: "".concat(spacing.small, " 0 ").concat(spacing.medium, " 0"),
    sidebarItemLogoFontSize: typography.fontSizeMedium
  };
};
export default generateComponentTheme;